import React from "react";
import {  useNavigate } from 'react-router-dom';
import logo from "../images/logo_ticket_buydeal.jpg";
import '../css/homepage_org.css';

function Header() {
	const navigate = useNavigate();
  return (
    <header className="app-header">
		<div className="appheader-inner">
			<div className="logo" onClick={() => navigate("/")}>
				<img src={logo} alt=""/>
		  		<h1>Buydeal.EU</h1>
			</div>
		</div>
    </header>

  );
}

export default Header;
